/**
 * 首页组件
 *
 * 包含：Hero区、创作智能体、记忆系统、付费计划、使用场景
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { HeroSection } from './components/HeroSection';
import { AgentShowcase } from './components/AgentShowcase';
import { MemorySystem } from './components/MemorySystem';
import { PricingSection } from './components/PricingSection';
import { UseCases } from './components/UseCases';
import { FooterSection } from './components/FooterSection';

const HomePage: React.FC = () => {
  const navigate = useNavigate();

  const handleStartClick = () => navigate('/login');
  const handleLearnMoreClick = () => {
    // 滚动到创作智能体区域
    const element = document.getElementById('agent-showcase');
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      {/* Hero 区域 */}
      <HeroSection 
        onStartClick={handleStartClick}
        onLearnMoreClick={handleLearnMoreClick}
      />

      {/* 创作智能体展示 */}
      <div id="agent-showcase">
        <AgentShowcase />
      </div>

      {/* 持久化记忆系统 */}
      <MemorySystem />

      {/* 使用场景 */}
      <UseCases />

      {/* 付费计划 */}
      <PricingSection />

      {/* 页脚 */}
      <FooterSection />
    </div>
  );
};

export default HomePage;
